import { Client, PackageErrorActionType } from '@halo/chat-sdk';
import type { ClientInitOptions, ClientOptions } from '@halo/chat-sdk';
import { type StateCreatorEnhance } from '@halo/zustand-enhance';
import { WsStatus, type PackageError } from '@halo/chat-sdk';
import { setAutoFreeze } from 'immer';
import type { AppStore } from '../main';

setAutoFreeze(false);

export type CreateClientOptions = ClientOptions;

export type InitClientOptions = ClientInitOptions;

export interface ClientStore {
  // Client
  wsStatus: WsStatus;
  networkErrorCode: number | undefined;
  packageErrorMap: Record<string, PackageError>;
  client: Client | undefined;
  initTrigger: object | undefined;
  createClient: (options: CreateClientOptions) => void;
  initClient: (options: ClientInitOptions) => Promise<void>;
  disposeClient: () => void;
}

export const clientStoreCreator: StateCreatorEnhance<AppStore> = (set, get, instance) =>
  ({
    // Client
    wsStatus: WsStatus.Closed,
    client: undefined,
    initTrigger: undefined,
    packageErrorMap: {},
    createClient: (options) => {
      set({ client: new Client(options) });
    },
    initClient: async (options) => {
      const client = get().client;
      if (client) {
        client.addEventListener('WsStateChanged', async ({ detail: { state } }) => {
          set({ wsStatus: state });
          // TODO amo: Optimize
          if (state === WsStatus.Open) {
            await client.Api.session.updateSessions(false);
          }
        });

        client.addEventListener('NetworkError', async ({ detail: { status_code } }) => {
          set({ networkErrorCode: status_code });
        });

        client.addEventListener('PackageErrorChanged', async ({ detail: { list } }) => {
          set((store) => {
            const { packageErrorMap } = store;
            list.forEach((item) => {
              if (!item.related_id) {
                const { user } = get();
                item.related_id = user?.user_id;
              }
              switch (item.ope_type) {
                case PackageErrorActionType.ADD:
                  packageErrorMap[item.related_id] = item;
                  break;
                case PackageErrorActionType.REMOVE:
                  delete packageErrorMap[item.related_id];
                  break;
              }
            });
          });
        });

        await client.init(options);
      }
    },
    disposeClient: () => {
      const { client } = get();
      if (client) {
        client[Symbol.dispose]();
        set(instance.getInitialState());
      }
    },
  }) as AppStore;
